module.exports = __webpack_public_path__ + "img/CAVIN_Logo_black.215c6943.png";